/* eslint-disable camelcase */
/**
 * Class HubspotForms
 */
class HubspotForms {
	form: HTMLElement;

	constructor(element: HTMLElement) {
		this.form = element;

		this.init();
	}

	init() {
		const hubspotVars = {
			portalId: this.form.getAttribute('data-hubspot-portal-id'),
			formId: this.form.getAttribute('data-hubspot-form'),
			target: '#' + this.form.getAttribute('id'),
			cssRequired: '',
			css: '',
			locale: document.querySelector('html')?.getAttribute('lang'),
			onFormReady: () => {
				this.setNotificationEmail('#' + this.form.getAttribute('id'));
			},
			onFormSubmitted: () => {
				const practiceTitle =
					document.querySelector<HTMLElement>('.provider-hero__title')?.textContent;
				if (practiceTitle) {
					window.dataLayer = window.dataLayer || [];
					window.dataLayer.push({
						event: 'finda',
						event_action: `practice_form_submitted`,
						location_name: practiceTitle,
					});
				}
			},
		};

		hbspt.forms.create(hubspotVars);
	}

	setNotificationEmail(formTarget: string) {
		const form = document.querySelector<HTMLElement>(formTarget);
		if (null === form) return;

		const notificationEmail = form.getAttribute('data-notification-email');
		if (!notificationEmail) return;

		const hiddenField = this.form.querySelector<HTMLInputElement>(
			'input[type="hidden"][name="notification_email"]'
		);

		if (hiddenField) {
			hiddenField.value = notificationEmail;
		}
	}
}

const blockHubspotForms = document.querySelectorAll<HTMLElement>('[data-hubspot-form]');
blockHubspotForms.forEach((el) => {
	new HubspotForms(el);
});
